import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Discount Coupon
function creatDiscountCoupon(params: any) {
    const baseUrl = `/disccoup/createcpn`;
    return api.create(`${baseUrl}`, params);
}
// update Discount Coupon
function updateDiscountCoupon(params: any) {
    const baseUrl = '/disccoup/updatecpn';
    return api.update(`${baseUrl}`, params);
}

// get all Discount Coupons
function getAllDiscountCoupons(params: any) {
    const baseUrl = '/disccoup/getcpnlist';
    return api.create(`${baseUrl}`, params);
}

// get Discount Coupon
function getDiscountCoupon(params: any) {
    const baseUrl = '/disccoup/getcpn';
    return api.create(`${baseUrl}`, params);
}

export { creatDiscountCoupon, updateDiscountCoupon, getAllDiscountCoupons, getDiscountCoupon };
